export default "__VITE_ASSET__f61c1f0b__"